import React from 'react';
import SnackBar from 'material-ui/Snackbar';
import Loading from '../components/_common/Loader/NameRouteLoader';
import { customPCPConfig } from '../../server/utils/customPCPConfig';

const SIZE_PER_PAGE = window.innerWidth > 2100 ? 12 : 8; // 12 products per page

function getDataFromQuery(query: { data: string }) {
  const decoded = decodeURI(query.data);
  return typeof decoded === 'string' ? JSON.parse(decoded) : decoded;
}

export const getVarietal = (name, filterByVarietal) => {
  switch (true) {
    default:
      return filterByVarietal;
    case Array.isArray(name.match('brut')):
      return ['brut'];
    case Array.isArray(name.match('cabernet')):
      return ['cabernet', 'redblend', 'pinotnoire'];
    case Array.isArray(name.match('chardonnay')):
      return [
        'chardonnay',
        'sauvignonblanc',
        'fume-blanc',
        'muscatcanelli',
        'pinotgrigio',
      ];
    case Array.isArray(name.match('dessert')):
      return ['dessert', 'syrah', 'cabernet'];
    case Array.isArray(name.match('fume-blanc')):
      return ['sauvignonblanc', 'muscatcanelli', 'pinotgrigio', 'riesling'];
    case Array.isArray(name.match('grigio')):
      return ['pinotgrigio', 'riesling', 'muscatcanelli', 'rose'];
    case Array.isArray(name.match('merlot')):
      return ['merlot', 'cabernet', 'pinotnoire', 'zinfandel'];
    case Array.isArray(name.match('muscat')):
      return ['muscatcanelli', 'pinotgrigio', 'riesling', 'rose'];
    case Array.isArray(name.match('riesling')):
      return ['riesling', 'pinotgrigio', 'muscatcanelli', 'rose'];
    case Array.isArray(name.match('pinot-noir')):
      return ['pinotnoir', 'cabernet', 'merlot', 'redblend', 'zinfandel'];
    case Array.isArray(name.match('red')):
      return ['redblend', 'cabernet', 'pinotnoire'];
    case Array.isArray(name.match('red-blend')):
      return ['redblend', 'cabernet', 'pinotnoire', 'merlot', 'zinfandel'];
    case Array.isArray(name.match('rose')):
      return ['rose', 'pinotgrigio', 'riesling', 'muscatcanelli'];
    case Array.isArray(name.match('sauvignon')):
      return ['fume-blanc', 'sauvignonblanc', 'chardonnay'];
    case Array.isArray(name.match('syrah')):
      return ['syrah', 'dessert', 'pinotnoir'];
    case Array.isArray(name.match('zinfandel')):
      return ['zinfandel', 'merlot', 'pinotnoire', 'cabernet', 'pinotnoire'];
  }
};

/* Route handler Functions */
export const prepareReceiptPageParams = params => {
  return params;
};

export const prepareEventPageParams = params => {
  const { eventId } = params;

  // trinityPartyId can be used if doesnt have the uuid format.
  if (eventId.indexOf('-') === -1) {
    return {
      ...params,
      trinityPartyId: eventId,
      eventId: null,
    };
  }

  return {
    ...params,
    eventId,
  };
};

export const prepareCeoHomePageParams = params => {
  const { customUrl } = params;
  return {
    ...params,
    customUrl,
  };
};

// export const preparePasswordResetParams = (params, { location }) => {
//   const { email, token } = location.query;
//   if (email) {
//     localStorage.setItem('email', email);
//     localStorage.setItem('token', token);
//   }
//   return {
//     ...params,
//     email,
//     token,
//   };
// };
/* prepares custom route parameters for custom PCP & PDP pages.
   Custom params such as 'productsOnly' are set in customPCPConfig.js'
 */
const prepareCustomParams = ({ category }) => {
  // const route = location.pathname.match(/([^\/]*)\/*$/)[1];
  const isCustomPage = customPCPConfig[category];
  const productCategories = isCustomPage
    ? isCustomPage.productCategories
    : ['any'];
  const productsExclude =
    isCustomPage && isCustomPage.productsExclude
      ? isCustomPage.productsExclude
      : ['any'];
  const productsOnly =
    isCustomPage && isCustomPage.productsOnly
      ? isCustomPage.productsOnly
      : ['any'];
  return { productCategories, productsExclude, productsOnly };
};

export const prepareProductCatalogParams = (params, match) => {
  const { location } = match;
  const { state } = location;
  const { category } = params;
  const customParams = prepareCustomParams({ category });

  const { productsExclude, productsOnly, productCategories } = customParams;
  if (state) {
    const {
      count,
      sortBy,
      filterPrice,
      filterByGiftCategories,
      filterByCause,
      filterByVarietal,
      filterByType,
    } = state;
    return {
      ...params,
      count: count || SIZE_PER_PAGE,
      sortBy,
      category,
      filterPrice,
      filterByGiftCategories,
      filterByCause,
      filterByVarietal,
      filterByType,
      productCategories,
      productsExclude,
      productsOnly,
    };
  }
  return {
    ...params,
    count: SIZE_PER_PAGE,
    sortBy: 'bestSellers',
    category,
    filterPrice: ['any'],
    filterByGiftCategories: ['any'],
    filterByCause: ['any'],
    filterByVarietal: ['any'],
    filterByType: ['any'],
    productCategories,
    productsExclude,
    productsOnly,
  };
};

export const prepareSSOPageParams = (params, { location }) => {
  const { query } = location;
  const { clientId, client_id } = query;

  return {
    ...params,
    clientId: clientId || client_id,
  };
};

export const prepareRelatedProductsParams = (params, { location }) => {
  const { name } = params;
  const { state } = location;
  if (state) {
    const {
      category,
      reviewCount,
      filterPrice,
      filterByGiftCategories,
      filterByCause,
      filterByVarietal,
      filterByType,
    } = state;
    const customParams = prepareCustomParams({ category });
    const { productsExclude, productsOnly, productCategories } = customParams;

    let relatedCategory = category;
    const relatedFilterByGiftCategories = filterByGiftCategories;
    const relatedFilterByCause = filterByCause;
    const relatedFilterPrice = filterPrice;
    let relatedFilterByVarietal = filterByVarietal;
    const relatedFilterByType = filterByType;
    switch (true) {
      case relatedCategory === 'coffee':
        relatedCategory = 'gift';
        break;
      case Array.isArray(name.match('box')):
        relatedCategory = 'gift-wine';
        break;
      case Array.isArray(name.match('crate')):
        relatedCategory = 'gifts';
        break;
      case Array.isArray(name.match('gift')):
        relatedCategory = 'gift-wine';
        break;
      case Array.isArray(name.match('pack')):
        if (
          name === 'california-brut-sparkling-wine-silver-glitter-three-pack'
        ) {
          relatedCategory = 'wine-glitter';
        } else {
          relatedCategory = 'wine-collection-mixed';
        }
        break;
      case Array.isArray(name.match('glitter')):
        relatedCategory = 'wine-glitter';
        relatedFilterByVarietal = ['any'];
        break;
      case relatedCategory === 'wine-collection-iconic':
        relatedCategory = 'wine-red';
        relatedFilterByVarietal = ['cabernet'];
        break;
      case relatedCategory === 'wine-collection-signature' ||
        relatedCategory === 'wine-collection-limited':
        relatedCategory = 'wine-red';
        if (Array.isArray(name.match('pinot'))) {
          relatedFilterByVarietal = ['pinotnoir'];
        } else {
          relatedFilterByVarietal = ['cabernet'];
        }
        break;
      case Array.isArray(name.match('rose')):
        relatedCategory = 'wine-white';
        break;
      case Array.isArray(name.match('sparkling')):
        relatedCategory = 'wine-sparkling';
        break;
      case !Array.isArray(name.match('gift')):
        relatedFilterByVarietal = getVarietal(
          name,
          relatedFilterByVarietal,
          relatedCategory,
        );
        relatedCategory = category;
        break;
      default:
        relatedCategory = 'wine';
        break;
    }
    return {
      ...params,
      category,
      productName: name,
      reviewCount,
      relatedFilterPrice,
      relatedFilterByCause,
      relatedCategory,
      relatedFilterByType,
      relatedFilterByVarietal,
      relatedFilterByGiftCategories,
      productCategories,
      productsExclude,
      productsOnly,
    };
  }
  return {
    ...params,
    productName: name,
    relatedCategory: 'wine-white',
    relatedFilterByType: ['any'],
    relatedFilterByVarietal: ['any'],
    relatedFilterByCause: ['any'],
    relatedFilterPrice: ['any'],
    relatedFilterByGiftCategories: ['any'],
    productCategories: ['any'],
    productsExclude: ['any'],
    productsOnly: ['any'],
  };
};

export const prepareBecomeACeoHomePageParams = () => ({
  pageNumber: 1,
  pageCount: 50,
});

export const lazyLoadImpactPage = () =>
  import('../components/Layouts/StaticPages/ImpactPage/ImpactPage').then(
    module => module.default,
  );

export const lazyLoadLoginPage = () =>
  import('../components/Layouts/Authentication/Login').then(
    module => module.default,
  );

export const lazyLoadRecoveryPage = () =>
  import('../components/Layouts/Authentication/Recovery').then(
    module => module.default,
  );
export const lazyLoadAboutUsPage = () =>
  import('../components/Layouts/StaticPages/AboutUsPage/AboutUsPage').then(
    module => module.default,
  );

export const lazyLoadThisIsATreePage = () =>
  import(
    '../components/Layouts/StaticPages/ThisIsATreePage/ThisIsATreePage'
  ).then(module => module.default);

export const lazyLoadCorporatePage = () =>
  import('../components/Layouts/StaticPages/CorporatePage/CorporatePage').then(
    module => module.default,
  );

export const lazyLoadHostATastingPage = () =>
  import(
    '../components/Layouts/StaticPages/HostATastingPage/HostATastingPageV2'
  ).then(module => module.default);

export const lazyLoadWinemakingPage = () =>
  import(
    '../components/Layouts/StaticPages/WineMakingPage/WineMakingPage'
  ).then(module => module.default);

export const lazyLoadWinemakingPagev2 = () =>
  import(
    '../components/Layouts/StaticPages/WineMakingPage_v2/WinemakingPagev2'
  ).then(module => module.default);

export const lazyLoadVisitPage = () =>
  import('../components/Layouts/StaticPages/Visit/Visit').then(
    module => module.default,
  );

export const lazyLoadRecap2017Page = () =>
  import(
    '../components/Layouts/StaticPages/Recap2017Page/Recap2017Page.tsx'
  ).then(module => module.default);

export const lazyLoadFaqPage = () =>
  import('../components/Layouts/StaticPages/FaqPage/FaqPage').then(
    module => module.default,
  );

export const lazyLoadReturnsPage = () =>
  import('../components/Layouts/StaticPages/ReturnsPage/ReturnPage').then(
    module => module.default,
  );

export const lazyLoadPrivacyPage = () =>
  import(
    '../components/Layouts/StaticPages/PrivacyPolicyPage/PrivacyPolicyPage'
  ).then(module => module.default);

// export const lazyLoadPasswordResetPage = () =>
//   import('../components/Layouts/ResetPasswordPage/ResetPasswordPage').then(
//     module => module.default,
//   );

export const lazyLoadProductCatalog = () =>
  import(
    '../components/Layouts/ProductPage/ProductsCatalog/ProductsCatalog'
  ).then(module => module.default);

// export const lazyLoadBlogPage = () =>
//   import('../components/Layouts/Blog/BlogPage/BlogPage').then(
//     module => module.default,
//   );

// export const lazyLoadBlogPostPage = () =>
//   import('../components/Layouts/Blog/BlogPostPage/BlogPostPage').then(
//     module => module.default,
//   );

// export const lazyLoadCheckout = () =>
//   import('../components/Layouts/CheckoutV3/CheckoutRenderer.tsx').then(
//     module => module.default,
//   );

export const lazyLoadChatBot = () =>
  import('../components/_common/ChatBot/ChatBotWrapper.tsx').then(
    module => module.default,
  );

// export const lazyLoadDesignGuide = () =>
//   import('../components/Layouts/DesignGuide/DesignGuide.tsx').then();

export const lazyLoadShopLandingPage = () =>
  import('../components/Layouts/ShopLandingPage/ShopLandingPage').then(
    module => module.default,
  );

export const lazyLoadHomePage = () =>
  import('../components/Layouts/HomePage/HomePage').then(module => {
    return module.default;
  });

export const lazyLoadMyAccountPage = () =>
  import('../components/Layouts/AccountPage/MyAccount/MyAccountPage').then(
    module => module.default,
  );

export const lazyLoadOrdersPage = () =>
  import('../components/Layouts/AccountPage/Orders/OrdersPage').then(
    module => module.default,
  );

// export const lazyLoadFavoritesPage = () =>
//   import('../components/Layouts/AccountPage/Favorites/FavoritesPage').then(
//     module => module.default,
//   );

// export const lazyLoadCEEnrollment = () =>
//   import('../components/Layouts/CEEnrollment/CEEnrollment').then(
//     module => module.default,
//   );

export const lazyLoadGrapefulClub = () =>
  import('../components/Layouts/GrapefulClub/GrapefulClub').then(
    module => module.default,
  );

export const lazyLoadGrapefulClubPage = () =>
  import('../components/Layouts/GrapefulClubPage/TheGrapefulClubPage').then(
    module => module.default,
  );

export const lazyLoadGrapefulClubPromo = () =>
  import('../components/Layouts/GrapefulClubPromo/TheGrapefulClubPromo').then(
    module => module.default,
  );

export const lazyLoadTrinityLogin = () =>
  import('../components/Layouts/TrinityLogin/TrinityLogin').then(
    module => module.default,
  );

export const lazyLoadSubscriptionSettingsPage = () =>
  import(
    '../components/Layouts/SubscriptionsSettingsPage/SubscriptionsSettingsPage.tsx'
  ).then(module => module.default);

export const lazyLoadSubscriptionPage = () =>
  import('../components/Layouts/AccountPage/Subscriptions/index.tsx').then(
    module => module.default,
  );

export const lazyLoadAddressesPage = () =>
  import('../components/Layouts/AccountPage/Addresses/AddressesPage').then(
    module => module.default,
  );

export const lazyLoadPaymentsPage = () =>
  import('../components/Layouts/AccountPage/Payments/PaymentsPage').then(
    module => module.default,
  );

export const lazyLoadRewardsPage = () =>
  import('../components/Layouts/AccountPage/Rewards').then(
    module => module.default,
  );

export const lazyLoadReceiptPage = () =>
  import('../components/Layouts/ReceiptPage/ReceiptPage').then(
    module => module.default,
  );

export const lazyLoadWeddingsPage = () =>
  import('../components/Layouts/StaticPages/WeddingsPage/WeddingsPage').then(
    module => module.default,
  );

export const lazyLoadSipsterhoodPage = () =>
  import(
    '../components/Layouts/StaticPages/SipsterhoodPage/SipsterhoodPage'
  ).then(module => module.default);

export const lazyLoadReferralCodeLookup = () =>
  import('../components/Layouts/ReferralTracking/ReferralCodeLookup').then(
    module => module.default,
  );

export const lazyLoadReferralCodeGenerate = () =>
  import('../components/Layouts/ReferralTracking/ReferralCodeGenerate').then(
    module => module.default,
  );

export const lazyLoadEventPage = () =>
  import('../components/Layouts/EventPage/EventPage').then(
    module => module.default,
  );
export const lazyLoadBecomeACeoPage = () =>
  import(
    '../components/Layouts/StaticPages/BecomeACeoPage/BecomeACeoPageV2'
  ).then(module => module.default);

export const lazyLoadSSOPage = () =>
  import('../components/Layouts/StaticPages/SSOPage/SSOPage').then(
    module => module.default,
  );

export const lazyLoadCeoPage = () =>
  import('../components/Layouts/CeoPage/CeoPage').then(
    module => module.default,
  );

export const lazyLoadAdminPage = () =>
  import('../components/Layouts/AdminPage/AdminPage').then(
    module => module.default,
  );

export const lazyLoadAccountPage = () =>
  import('../components/Layouts/AccountPage/AccountPage').then(
    module => module.default,
  );

export const lazyLoadCeoHomePage = () =>
  import('../components/Layouts/CeoHomePage/CeoHomePage').then(
    module => module.default,
  );

export const lazyLoadShimmer2018Page = () =>
  import(
    '../components/Layouts/StaticPages/Shimmer2018Page/Shimmer2018Page'
  ).then(module => module.default);

export const lazyLoadGroupFundraiserPage = () =>
  import('../components/Layouts/GroupFundraiser/GroupFundraiserPage').then(
    module => module.default,
  );

// export const lazyLoadPaymentsPage = () => (
//   import('../components/Layouts/AccountPage/Payments/PaymentsPage').then(module => module.default)
// );

export function getSquareRedirectUrl(stateObject) {
  const {
    location: { query },
  } = stateObject.match;
  const fromiOS = !!query.data;
  let errorCode;
  let orderId = '';
  let success = false;

  if (fromiOS) {
    const data = getDataFromQuery(query);
    const state =
      typeof data.state === 'string' ? JSON.parse(data.state) : data.state;

    if (data.transaction_id) {
      success = true;
    } else {
      errorCode = data.error_code;
    }

    ({ orderId } = state);
  } else {
    const metadata = JSON.parse(query['com.squareup.pos.REQUEST_METADATA']);

    if (query['com.squareup.pos.CLIENT_TRANSACTION_ID']) {
      success = true;
    } else {
      errorCode = query['com.squareup.pos.ERROR_CODE'];
    }

    ({ orderId } = metadata);
  }

  if (errorCode) {
    return `/order/${orderId}?squareSuccess=${success}&errorCode=${errorCode}`;
  }

  return `/order/${orderId}?squareSuccess=${success}`;
}

const errorMessageStyle = {
  zIndex: 4000,
};
const errorMessageBodyStyle = {
  backgroundColor: '#de5949',
  textAlign: 'center',
  zIndex: '4000',
};

const errorContentStyle = {
  marginTop: 6,
  lineHeight: '16px',
};

const noop = () => {};

function ErrorForPersistedQuery() {
  return (
    <SnackBar
      message="There was a disconnect to our server, please refresh your browser."
      open
      style={errorMessageStyle}
      bodyStyle={errorMessageBodyStyle}
      contentStyle={errorContentStyle}
      onRequestClose={noop}
    />
  );
}

export const renderComponent = args => {
  const { Component, props, error, variables } = args;
  if (error) {
    if (error.message.includes(`queryId`)) {
      return <ErrorForPersistedQuery />;
    }
  }
  if (!Component) {
    return <Loading />;
  }
  return <Component {...props} variables={variables} />;
};
